import React from "react";
import { useLocation } from "react-router";
import Button from "../../../components/Common/Button/Button";
import Input from "../../../components/Common/ReactForm/Input/Input";
import ReportGraph from "../ReportGraph/ReportGraph";
import classes from "./ReportGraphFilterLayout.module.scss";

const ReportGraphFilterLayout = ({
  inputField,
  graphs,
  isInputFiels = false,
}) => {
  const primaryColor = JSON.parse(localStorage.getItem("themeData")).CustomData
    .PrimaryColor1;
  const location = useLocation();

  return (
    <div className={classes.graphFilterLayout}>
      {isInputFiels && (
        <div className={classes.filterLayout}>
          <div className={classes.inputField}>
            {inputField?.map((field) => {
              return (
                <div className={classes.field}>
                  <Input
                    isFromDate={field?.isFromDate}
                    type={field?.type}
                    isDisabled={field?.isDisabled}
                    isInputDisabled={field?.isInputDisabled}
                    height={field?.height}
                    width={field?.width}
                    label={field?.label}
                    name={field?.name}
                    isCombine={field?.isCombine}
                    placeholder={field?.placeholder}
                    min={field?.min}
                    searchTagsList={field?.searchTagsList}
                    setSelectedId={field?.setSelectedId}
                    isMulti={field?.isMulti}
                    isRequired={field?.isRequired}
                    isLimit={field?.isLimit}
                    defaultValue={field?.defaultValue}
                    options={field?.options}
                    onClick={field?.onClick}
                    onChange={field?.onChange}
                    fieldValue={field?.fieldValue}
                    maxSelected={field?.maxSelected}
                    validationLabel={field?.validationLabel}
                    selectedValue={field?.selectedValue}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div className={classes.graphLayout}>
        {graphs?.map((field) => {
          return (
            <div className={classes.graphs}>
              <ReportGraph
                type={field?.type}
                heading={field?.heading}
                xAxesText={field?.xAxesText}
                yAxesText={field?.yAxesText}
                graphData={field?.data}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReportGraphFilterLayout;
